import styled from 'styled-components';

export const SuccessInviteContainer = styled.div`
  text-align: center;
`;
